module.exports = __webpack_public_path__ + "fonts/gothica1-extrabold-webfont.cb50b92.woff";